import { render } from "./tenant-list.vue?vue&type=template&id=1b3bc0cf"
import script from "./tenant-list.vue?vue&type=script&lang=js"
export * from "./tenant-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__